export default "/images/vendor/flag-icon-css/flags/4x3/mg.svg?f9101073ea57c9f7664cd8f4cc26effa";